// Texts of the ERP area "CRM" (clientes, contatos, interações).
export default {
  crm: {
    title: 'Clientes',
    subtitle: 'Em que pé está cada cliente e quem abordar primeiro.',
    searchPlaceholder: 'Buscar em qualquer coluna (cliente, consultor, fase, próximo passo…)',
    emptyTitle: 'Nenhum cliente cadastrado',
    emptyText: 'Cadastre o primeiro cliente em "Novo cliente" para acompanhá-lo aqui.',
    totalValue: 'Valor total',
    proposals: 'Nenhuma proposta | 1 proposta | {count} propostas',
    invoices: 'Nenhuma fatura | 1 fatura | {count} faturas',
    open: '{count} em aberto',
    lastContact: 'Último contato em {date}',
    noInteractions: 'Sem acompanhamentos registrados',
    columns: {
      customer: 'Cliente',
      stage: 'Fase',
      relationship: 'Relacionamento',
      consultant: 'Consultor',
      lastContact: 'Último contato',
      next: 'Próximo passo',
      openValue: 'Proposta em aberto',
      referrer: 'Indicado por',
    },
    referralFilter: { label: 'Indicação', with: 'Com indicação', without: 'Sem indicação' },
    shortcuts: {
      label: 'Atalhos',
      approach: 'Para abordar',
      uncovered: 'Sem próxima atividade',
      open: 'Proposta em aberto',
      mine: 'Minha carteira',
      all: 'Todos',
      inactive: 'Inativos',
    },
    summary: {
      customers: 'Nenhum cliente | 1 cliente | {n} clientes',
      approach: 'nenhum para abordar | 1 para abordar | {n} para abordar',
      openValue: '{value} em propostas abertas',
    },
    toApproach: 'Abordar',
    approachEmpty: 'Ninguém para abordar agora: todos têm um próximo passo em dia.',
    stage: { prospect: 'Prospect', negotiating: 'Negociando', customer: 'Cliente', inactive: 'Inativo' },
    relationship: { label: 'Relacionamento', none: '—', low: 'Baixo', medium: 'Médio', high: 'Alto' },
    coverage: {
      covered: 'Coberta',
      no_activity: 'Sem próxima atividade',
      overdue_only: 'Só atividades atrasadas',
      no_owner: 'Sem responsável',
      excluded: 'Atividade não exigida',
    },
    potential: { label: 'Potencial', none: '—', low: 'Baixo', medium: 'Médio', high: 'Alto' },
    contact: {
      editTitle: 'Acompanhamento',
      // Reunião: always through the meeting (19/10/2026).
      meeting: {
        chooseCustomer: 'Escolha o cliente para ver as reuniões dele.',
        hint: 'Reunião se registra na própria reunião: assim o relatório, o e-mail aos sócios e o histórico são uma coisa só.',
        recordThis: 'Registrar esta',
        none: 'Nenhuma reunião marcada e ainda não registrada com este cliente.',
      },
      title: 'Registrar contato',
      save: 'Registrar',
      customer: 'Cliente',
      chooseCustomer: 'Escolha o cliente',
      saved: 'Contato registrado no histórico do cliente.',
      scheduleNext: 'Agendar o próximo passo',
      nextType: 'Próximo passo',
      nextDate: 'Quando',
    },
    neverContacted: 'Nunca',
    today: 'Hoje',
    daysAgo: 'Há 1 dia | Há {n} dias',
    timeline: {
      kindLabel: 'Tipo',
      allKinds: 'Tudo',
      kind: { contact: 'Contato', meeting: 'Reunião', proposal: 'Proposta', reschedule: 'Reagendamento', change: 'Mudança comercial' },
      from: 'De',
      to: 'Até',
      author: 'Quem',
      anyone: 'Todos',
      clear: 'Limpar filtros',
      more: 'Mostrando {shown} de {total}. Use os filtros para ver os mais antigos.',
      customer: 'Cliente',
      anyCustomer: 'Todos',
      reportSent: 'Relatório enviado',
    },
    // CRM › Histórico (22/10/2026).
    history: {
      title: 'Histórico',
      subtitle: 'O que já foi feito com os clientes, do mais recente para o mais antigo: contatos, reuniões realizadas, relatórios enviados, atividades feitas e propostas. Sem período escolhido, os últimos 30 dias.',
    },
    detail: {
      contacts: 'Contatos',
      noContacts: 'Nenhuma pessoa de contato.',
      projects: 'Projetos',
      noProjects: 'Nenhum projeto.',
      commercial: 'Propostas e faturas',
      noCommercial: 'Nenhuma proposta ou fatura.',
      kind: { proposal: 'Proposta' },
      interactions: 'Acompanhamentos',
      noHistory: 'Nenhum contato ainda. Use "Registrar contato" para lançar uma ligação, um WhatsApp, um e-mail ou uma reunião.',
      newInteraction: 'Adicionar acompanhamento',
      added: 'Acompanhamento registrado',
      meetingHint: 'Reuniões lançadas na tela Reuniões já aparecem aqui sozinhas; use este tipo só para uma reunião que não foi lançada lá.',
      openMeeting: 'Abrir reunião',
      openContact: 'Abrir',
      type: 'Tipo',
      date: 'Data',
      project: 'Projeto',
      task: 'Tarefa',
      noTask: 'Sem tarefa',
      description: 'O que aconteceu',
      add: 'Adicionar',
      by: 'por {name}',
      deleteInteraction: 'Excluir acompanhamento',
      deleteInteractionOf: 'Excluir o acompanhamento de {date}',
      deleteInteractionTitle: 'Excluir este acompanhamento?',
    },
    types: { note: 'Anotação', call: 'Ligação', email: 'E-mail', meeting: 'Reunião', other: 'Outro', whatsapp: 'WhatsApp' },
    status: {
      draft: 'Rascunho',
      sent: 'Enviado',
      approved: 'Aprovado',
      rejected: 'Recusado',
      expired: 'Expirado',
      paid: 'Pago',
      cancelled: 'Cancelado',
      in_progress: 'Em andamento',
      not_started: 'Não iniciado',
      waiting_customer: 'Aguardando cliente',
      blocked: 'Travado',
      completed: 'Concluído',
    },
  },
  projectCodes: {
    title: 'Códigos',
    intro: 'Projetos recebem um código como C26-014 (C = cliente, P = projeto próprio; ano e número), tarefas como C26-014.07 (o código do projeto e o número da tarefa) e contratos como CT26-001. O sistema gera ao criar, e eles nunca mudam nem se repetem. A sigla do cliente aparece ao lado, como rótulo.',
    allDone: 'Tudo tem código',
    pendingProjects: 'Nenhum projeto sem código | 1 projeto sem código | {count} projetos sem código',
    pendingTasks: 'Nenhuma tarefa sem código | 1 tarefa sem código | {count} tarefas sem código',
    pendingContracts: 'Nenhum contrato sem número | 1 contrato sem número | {count} contratos sem número',
    apply: 'Gerar os códigos',
    applyHint: 'Na ordem em que foram criados, pelo ano da criação. Tarefas internas sem projeto vão para o projeto Geral do ano (P26-000); tarefas de clientes sem projeto ficam sem código até entrarem num projeto.',
    applied: 'Nenhum código gerado | 1 código gerado | {count} códigos gerados',
  },
  cnpjLookup: {
    title: 'Consulta de CNPJ (ReceitaWS)',
    intro: 'No cadastro de clientes, ao digitar um CNPJ completo, os dados (razão social, endereço, telefone e e-mail) são preenchidos pela ReceitaWS.',
    free: 'Sem chave, usamos a consulta gratuita da ReceitaWS, limitada a 3 consultas por minuto. Com a chave do plano pago da sua empresa, não há esse limite.',
    apiKey: 'Chave da API (token) da ReceitaWS',
    apiKeyHint: 'Está no painel da sua conta em receitaws.com.br. Fica guardada cifrada e não é exibida de novo.',
    save: 'Salvar chave',
    saved: 'Chave da ReceitaWS salva',
    removed: 'Chave removida. Voltamos à consulta gratuita.',
    configured: 'Chave configurada',
    endsWith: 'termina em {hint}',
    updatedAt: 'alterada em {date}',
    replace: 'Trocar chave',
    remove: 'Remover chave',
  },
  // "Ver e-mail" (31/10/2026).
  emailView: {
    link: 'Ver e-mail',
    title: 'E-mail enviado',
    from: 'De',
    to: 'Para',
    cc: 'Cópia',
    bcc: 'Cópia oculta',
    subject: 'Assunto',
    sent: 'Enviado',
    download: 'Baixar anexo',
    noFile: 'O arquivo não está mais disponível.',
    loadError: 'Não foi possível abrir o e-mail.',
    status: { prepared: 'Preparado', sending: 'Enviando', sent: 'Enviado', failed: 'Não enviado' },
  },
  // Indicação (30/10/2026).
  referral: {
    title: 'Quem indicou este cliente',
    help: 'Se este cliente chegou por indicação de outro cliente (pessoa ou empresa), escolha quem indicou e a comissão desta indicação.',
    referredBy: 'Indicado por',
    noReferrer: 'Ninguém (cliente sem indicação)',
    commission: 'Comissão',
    kind: 'Tipo da comissão',
    value: 'Valor',
    valuePercent: 'Percentual (%)',
    valueMoney: 'Valor em reais (R$)',
    percent: 'Percentual (%)',
    fixed: 'Valor fixo (R$)',
    agreedWith: 'Combinado com quem indicou: {value}. Pode ser ajustado só para este cliente.',
    noAgreed: 'Nada combinado com quem indicou. Preencha aqui só para este cliente.',
    effect: 'Quando uma proposta deste cliente for aprovada, o sistema cria contas a pagar de comissão para {name}: uma para cada recebimento da proposta, 10 dias úteis depois de cada um.',
    effectFixed: 'Valor fixo: é pago uma só vez, na primeira proposta aprovada deste cliente.',
    example: 'Exemplo: em uma proposta de {base}, a comissão é {value}.',
    exampleMonthly: 'Exemplo: em uma proposta de {base} com mensalidade de {monthly}, a comissão é {value}.',
    exampleInstallments: 'Exemplo: em uma proposta de {base} com mensalidade de {monthly} e {n} parcelas, a comissão é {value}.',
    saveReferral: 'Salvar indicação',
    agreedTitle: 'Quando este cliente indicar alguém',
    agreedHelp: 'Comissão combinada com este cliente para cada pessoa ou empresa que ele indicar. Ela já vem preenchida ao escolher este cliente em "Indicado por" de outro cliente.',
    agreedNote: 'Mudar aqui não altera as indicações que já existem, a menos que você escolha aplicar a elas ao salvar.',
    saveAgreed: 'Salvar comissão combinada',
    noReferred: 'Este cliente ainda não indicou ninguém.',
    referredList: 'Já indicou 1 cliente | Já indicou {n} clientes',
    applyTitle: 'Aplicar a nova comissão a 1 cliente indicado? | Aplicar a nova comissão a {n} clientes indicados?',
    applyText: 'Estes clientes foram indicados por este cliente e têm outra comissão. Aplicar {value} a eles?',
    applyConfirm: 'Aplicar a 1 cliente | Aplicar a {n} clientes',
    applyKeep: 'Só salvar, sem aplicar',
    updateTitle: 'Atualizar as comissões já lançadas?',
    updateText: 'Já existem comissões a pagar geradas para as propostas deste cliente ({open} ainda sem pagamento, de {total}). Atualizar as não pagas com a nova configuração? As já pagas não mudam.',
    updateConfirm: 'Atualizar as não pagas',
    updateKeep: 'Só para as próximas',
    basis: {
      label: 'Calculada sobre',
      closed: 'Valor fechado do projeto',
      closed_and_month: 'Valor fechado + 1ª mensalidade',
      closed_and_installments: 'Valor fechado + mensalidades (uma por parcela)',
      hint: {
        closed: 'Só o valor do projeto. As mensalidades não geram comissão.',
        closed_and_month: 'O valor do projeto e mais uma mensalidade.',
        closed_and_installments: 'O valor do projeto e tantas mensalidades quanto o número de parcelas da proposta.',
      },
    },
    appliedToast: 'Comissão salva e aplicada a 1 cliente. | Comissão salva e aplicada a {n} clientes.',
  },
  customer: {
    title: 'Cliente',
    back: 'Voltar para {name}',
    backPlain: 'Voltar',
    facts: {
      closed: 'Fechado',
      open: 'Em aberto',
      openValue: '1 proposta · {value} | {n} propostas · {value}',
      projects: 'Projetos ativos',
      lastContact: 'Último contato',
      consultant: 'Consultor',
    },
    tabs: { relationship: 'Relacionamento', data: 'Dados' },
    editData: 'Editar dados',
    newMeeting: 'Nova reunião',
    newProposal: 'Nova proposta',
    type: 'Tipo',
    ownCompany: 'Própria empresa (projetos internos)',
    noDocument: 'Sem documento',
    stats: {
      approved: 'Fechado (propostas aprovadas e faturas)',
      open: 'Nenhuma proposta em aberto | 1 proposta em aberto | {count} propostas em aberto',
      projects: 'Projetos ativos',
      lastContact: 'Último contato',
    },
  },
  customers: {
    title: 'Clientes',
    subtitle: 'Empresas e pessoas atendidas, com os contatos de cada uma.',
    new: 'Novo cliente',
    searchPlaceholder: 'Nome, sigla, CNPJ ou CPF',
    emptyTitle: 'Nenhum cliente cadastrado',
    emptyText: 'Cadastre o primeiro cliente para usar no CRM, nos projetos e nas propostas.',
    views: { active: 'Ativos', inactive: 'Inativos' },
    emptyInactive: 'Nenhum cliente inativo',
    emptyInactiveText: 'Clientes inativados saem das listas e ficam aqui, com todo o histórico.',
    inactivate: 'Inativar',
    reactivate: 'Reativar',
    inactivateTitle: 'Inativar {name}?',
    inactivateText: 'O cliente sai das listas, do CRM e das opções de cliente, mas todo o histórico continua: propostas, projetos, tarefas, contratos e acompanhamentos. Ele fica na aba "Inativos", de onde pode ser reativado.',
    reactivateTitle: 'Reativar {name}?',
    reactivateText: 'O cliente volta para as listas e para as opções de cliente.',
    inactivated: '{name} foi inativado',
    reactivated: '{name} foi reativado',
    inactiveSince: 'Inativo desde {date}',
    inactiveBadge: 'Inativo',
    columns: { name: 'Nome / razão social', acronym: 'Sigla', document: 'Documento', phone: 'Telefone', email: 'E-mail', consultant: 'Consultor' },
    tabs: { data: 'Dados da empresa', contacts: 'Pessoas de contato' },
    dialogNew: 'Novo cliente',
    dialogEdit: 'Editar cliente',
    withoutDocument: 'Cadastrar sem documento',
    documentType: 'Tipo de documento',
    cnpj: 'CNPJ',
    cpf: 'CPF',
    lookup: 'Buscar dados',
    lookupDone: 'Dados da Receita preenchidos',
    lookupSituation: 'Situação na Receita: {situation}',
    // Quick create by CNPJ (17/10/2026).
    quickHint: 'Digite o CNPJ: os dados vêm da Receita e você só confirma.',
    lookingUp: 'Buscando os dados na Receita…',
    situation: 'Situação',
    reviewAll: 'Revisar ou completar os dados',
    withoutCnpj: 'Cadastrar sem CNPJ (CPF ou sem documento)',
    confirmCreate: 'Confirmar e cadastrar',
    lookupNotFound: 'CNPJ válido, mas não encontrado na Receita. Os dados não foram preenchidos automaticamente: preencha à mão e salve normalmente.',
    cnpjInvalid: 'CNPJ inválido. Confira os números.',
    cnpjIncomplete: 'CNPJ incompleto: são 14 caracteres.',
    legalName: 'Razão social',
    // Nome Fantasia (19/10/2026).
    tradeName: 'Nome fantasia',
    tradeNameHint: 'O nome usado nas telas e nas comunicações. Vazio = usa a razão social. Contratos e o aceite da proposta usam a razão social.',
    address: 'Endereço',
    // Localização e segmento (20/10/2026, Automação de Envios).
    postalCode: 'CEP',
    postalCodeHint: 'Ao digitar o CEP, a UF e o município são preenchidos.',
    cepNotFound: 'CEP não encontrado. Preencha a UF e o município.',
    state: 'UF',
    city: 'Município',
    segment: 'Segmento',
    segmentHint: 'A atividade principal. Vem do CNPJ; pode ser trocada. Usado para filtrar contatos nas campanhas.',
    contactName: 'Contato principal',
    email: 'E-mail comercial',
    phone: 'Telefone comercial',
    commercialHint: 'Os dados da empresa. As pessoas, com telefone e e-mail próprios, ficam em Pessoas de contato.',
    createdKeepOpen: 'Cliente criado. Agora você pode cadastrar as pessoas de contato.',
    codeSection: 'Projetos e carteira',
    acronym: 'Sigla (3 letras)',
    acronymHint: 'Aparece ao lado do código dos projetos e tarefas, como "C26-014 AYA". Não faz parte do código.',
    acronymAuto: 'Preenchida a partir do nome. Você pode trocar. Aparece ao lado do código dos projetos, como "C26-014 AYA".',
    acronymInUse: 'Esta sigla já é de {name}.',
    useSuggestion: 'Usar {acronym}',
    isOwnCompany: 'Representa a própria empresa (os projetos deste cliente são internos)',
    consultant: 'Consultor responsável (carteira)',
    consultantHint: 'Do cadastro de Funcionários. A carteira vai para o acesso ao sistema do funcionário.',
    consultantNone: 'Sem consultor',
    contacts: {
      empty: 'Nenhuma pessoa de contato.',
      add: 'Adicionar contato',
      name: 'Nome',
      role: 'Responsabilidade',
      phone: 'Telefone',
      email: 'E-mail',
      birthDate: 'Aniversário',
      notes: 'Observações',
      roles: ['Diretor', 'Gerente', 'Comercial', 'Operacional', 'Financeiro', 'Outro'],
      primary: 'Contato principal',
      primaryHint: 'Para trocar o contato principal, marque outra pessoa.',
      primaryFirstHint: 'A primeira pessoa do cliente é o contato principal.',
      primaryBadge: 'Principal',
      saveContact: 'Salvar contato',
      editContact: 'Editar contato',
    },
    deleteText:
      'O cliente sai de todas as listas e das opções de cliente, inclusive dos inativos. Se ele tiver acompanhamentos, propostas, faturas, projetos, tarefas, contratos, reuniões ou chamados, esses registros continuam e seguem mostrando o cliente; senão, ele é apagado com os contatos. Esta ação não pode ser desfeita.',
    deleted: '{name} foi excluído',
    archived: '{name} foi excluído. O histórico continua nas propostas, projetos e demais registros.',
    deletedSince: 'Cliente excluído em {date}. Ele só aparece no histórico e não pode ser alterado.',
    deletedBadge: 'Excluído',
  },
  // CRM › Atividades (08/10/2026).
  activities: {
    title: 'Atividades',
    subtitle: 'O que a equipe comercial tem a fazer com cada cliente: apresentações, retornos, propostas.',
    new: 'Nova atividade',
    shortcutsLabel: 'Situação das atividades',
    shortcuts: {
      pending: 'A fazer',
      today: 'Hoje',
      tomorrow: 'Amanhã',
      week: 'Esta semana',
      overdue: 'Atrasadas',
      upcoming: 'Próximas',
      done: 'Feitas',
      cancelled: 'Canceladas',
      all: 'Todas',
    },
    status: { pending: 'A fazer', done: 'Feita', cancelled: 'Cancelada' },
    overdue: 'Atrasada',
    filters: { type: 'Tipo', owner: 'Responsável', customer: 'Cliente', origin: 'Origem', from: 'De', to: 'Até', clear: 'Limpar filtros' },
    columns: {
      dueDate: 'Data',
      customer: 'Cliente',
      type: 'Atividade',
      contact: 'Contato',
      stage: 'Fase',
      priority: 'Prioridade',
      origin: 'Origem',
      owner: 'Responsável',
      status: 'Situação',
      completedOn: 'Feita em',
    },
    origin: { manual: 'Manual', automation: 'Automática', legacy: 'Anterior às automações' },
    priority: { high: 'Alta', medium: 'Média', low: 'Baixa' },
    byRule: 'pela regra “{name}”',
    actions: { label: 'Ações rápidas', next: 'Próxima ação', openCustomer: 'Abrir empresa' },
    note: {
      action: 'Anotar',
      title: 'Anotar na atividade',
      text: 'A anotação entra nas observações com a data e o seu nome. A atividade continua a fazer.',
      label: 'Anotação',
      save: 'Salvar anotação',
      added: 'Anotação registrada.',
    },
    reschedule: {
      action: 'Reagendar',
      title: 'Reagendar atividade',
      now: 'Hoje está para {date}.',
      date: 'Nova data',
      reason: 'Motivo (opcional)',
      reasonRequired: 'Motivo',
      automaticHint: 'Atividade criada por uma automação: o motivo fica registrado. A regra não muda.',
      done: 'Atividade reagendada para {date}.',
      history: 'Reagendamentos anteriores',
      count: 'reagendada 1 vez | reagendada {n} vezes',
      byEditHint: 'Mudar a data aqui também fica registrado como reagendamento (sem motivo). Para informar o motivo, use “Reagendar”.',
    },
    outcomes: {
      title: 'Resultados ao concluir',
      label: 'Resultado',
      quickHint: 'Sem resultado: conclusão rápida.',
      closesProposalHint: 'A proposta enviada deste cliente será marcada como recusada, com o texto abaixo como motivo.',
      noteRequired: 'O que aconteceu (obrigatório)',
      next: 'Agendar o próximo passo',
      nextTitle: 'Título do próximo passo',
      noNextHint: 'Sem próximo passo: se a empresa ficar sem atividade, o sistema agenda o próximo contato pela matriz de frequência.',
      completedWithNext: 'Atividade feita e próximo passo agendado.',
      proposalRejected: 'Atividade feita e proposta marcada como recusada.',
      editorHint:
        'As opções oferecidas ao concluir uma atividade deste tipo. Cada uma pode sugerir o próximo passo, pedir o que aconteceu ou recusar a proposta. As regras de automação podem ser disparadas por um resultado. Sem resultados: conclusão rápida.',
      result: 'Resultado',
      mode: { none: 'Sem próximo passo', days: 'Em alguns dias', date: 'Perguntar a data' },
      inDays: 'Em quantos dias',
      sameType: 'O mesmo tipo',
      noteRequiredFlag: 'Pede o que aconteceu',
      closesProposalFlag: 'Recusa a proposta',
      up: 'Subir',
      down: 'Descer',
      add: 'Adicionar resultado',
      useSuggested: 'Usar resultados sugeridos',
    },
    emptyTitle: 'Nenhuma atividade a fazer',
    emptyText: 'Agende a próxima ação com um cliente em "Nova atividade" (ou na tela do cliente).',
    dialogNew: 'Nova atividade',
    dialogEdit: 'Editar atividade',
    fields: {
      customer: 'Cliente',
      type: 'Tipo de atividade',
      dueDate: 'Data',
      contact: 'Contato do cliente',
      owner: 'Responsável',
      priority: 'Prioridade',
      dueTime: 'Horário (opcional)',
      notes: 'Observações',
      completedOn: 'Feita em',
      outcome: 'O que aconteceu',
    },
    chooseType: 'Escolha o tipo',
    chooseCustomer: 'Escolha o cliente',
    noContact: 'Nenhum',
    ownerHint: 'Vazio: o consultor do cliente.',
    schedule: 'Agendar',
    scheduled: 'Atividade agendada.',
    markDone: 'Marcar como feita',
    searchPlaceholder: 'Cliente, tipo, contato, responsável ou observação',
    details: 'Detalhes da atividade',
    completeTitle: 'Marcar atividade como feita',
    completeHint: 'Vira um acompanhamento no histórico do cliente.',
    completed: 'Atividade feita. Registrada no histórico do cliente.',
    dueOn: 'Prevista para {date}.',
    doneOn: 'Feita em {date}',
    doneHint: 'Está no histórico do cliente. Reabrir tira o acompanhamento de lá.',
    reopen: 'Reabrir',
    reopened: 'Atividade reaberta.',
    cancel: 'Cancelar atividade',
    cancelled: 'Atividade cancelada.',
    cancelTitle: 'Cancelar "{name}"?',
    cancelText: 'A atividade sai da lista de pendentes. Dá para reabrir depois.',
    deleteText: 'A atividade será excluída.',
    deleteDoneText: 'A atividade já foi feita: ela e o contato que registrou no histórico do cliente serão excluídos.',
    email: {
      title: 'Enviar e-mail',
      from: 'De',
      to: 'Para',
      toHint: 'Mais de um: separe com vírgula ou ponto e vírgula.',
      subject: 'Assunto',
      body: 'Texto',
      attachment: 'Anexo',
      send: 'Enviar e-mail',
      sent: 'O serviço de e-mail enviou para {to}. A atividade foi marcada como feita.',
      sentGmail: 'Enviado pelo seu Gmail para {to} (está nos seus Enviados). A atividade foi marcada como feita.',
      viaGmail: 'Vai pelo seu Gmail e fica nos seus Enviados.',
      template: 'Modelo',
      noTemplate: 'Sem modelo (escrever do zero)',
      suggestions: 'Contatos da empresa:',
      missing: 'Preencha antes de enviar: {list}. O e-mail não sai com campos em branco.',
      tryAgain: 'Tentar de novo',
      status: { prepared: 'Rascunho', sending: 'Enviando…', sent: 'Enviado', failed: 'Não enviado' },
      statusHint: {
        prepared: 'Ainda não enviado.',
        sending: 'O e-mail está na fila do serviço de envio. A atividade só é concluída quando o envio for confirmado.',
        sent: 'O provedor aceitou o e-mail para {to}. Isso não confirma a entrega nem a leitura.',
        failed: 'O serviço de e-mail não conseguiu enviar. A atividade continua em aberto.',
      },
      senderMissing: 'A empresa ainda não tem remetente de e-mail. Configure em Configurações › E-mail.',
      noSignature: 'Você ainda não tem assinatura: vai o seu nome.',
      cc: 'Cc (em cópia)',
      bcc: 'Cco (cópia oculta)',
      copyHint: 'Opcional. Mais de um: separe com vírgula.',
      bccHint: 'Você já vem aqui, para guardar o e-mail na sua caixa.',
      signatureAt: "Assinatura (no lugar de {'{'}assinatura{'}'}):",
    },
    signature: {
      title: 'Assinatura de e-mail',
      edit: 'Editar minha assinatura',
      panelTitle: 'Assinaturas de e-mail',
      panelIntro: "A assinatura de cada pessoa nos e-mails enviados pelas atividades do CRM. Vai no lugar de {'{'}assinatura{'}'} no texto do e-mail.",
      fields: { name: 'Nome', role: 'Cargo | Empresa', phone: 'Telefone', email: 'E-mail', website: 'Site' },
      image: 'Imagem à esquerda (logo ou foto)',
      replaceImage: 'Trocar a imagem',
      imageHint: 'PNG, JPG ou GIF, até 2 MB. Aparece com 160 px de largura.',
      removeImage: 'Remover a imagem',
      preview: 'Como fica no e-mail',
      columns: { person: 'Pessoa', login: 'Login', role: 'Cargo', status: 'Assinatura' },
      done: 'Cadastrada',
      missing: 'Sem assinatura',
    },
    customer: {
      title: 'Atividades',
      none: 'Nada a fazer com este cliente.',
      all: 'Ver todas as atividades do cliente',
    },
    // Reuniões como atividade (19/10/2026).
    meetings: {
      title: 'Reuniões',
      label: 'Reunião: {title}',
      state: { scheduled: 'Marcada', to_record: 'A registrar', held: 'Realizada', not_held: 'Não aconteceu' },
    },
    types: {
      new: 'Novo tipo de atividade',
      dialogNew: 'Novo tipo de atividade',
      dialogEdit: 'Editar tipo de atividade',
      fields: {
        name: 'Nome',
        description: 'Como fazer (o padrão)',
        channel: 'Aparece no histórico como',
        defaultDueDays: 'Prazo padrão (dias)',
        active: 'Tipo ativo',
        emailSubject: 'Assunto do e-mail',
        emailBody: 'Texto do e-mail',
      },
      emailTitle: 'E-mail',
      emailHint: 'Com assunto e texto, a atividade ganha "Enviar e-mail", que sai em nome de quem clica. Campos: {fields}.',
      templateHint: 'Com um modelo padrão, as atividades deste tipo ganham "Enviar e-mail". Os modelos (texto, variáveis e anexo) ficam em Cadastros › Automações comerciais › Modelos de e-mail.',
      defaultTemplate: 'Modelo de e-mail padrão',
      noTemplate: 'Nenhum (sem "Enviar e-mail")',
      fileDrop: 'Anexo do e-mail (PDF, até 8 MB)',
      replaceFile: 'Trocar o anexo',
      fileHint: 'Vai em todo e-mail deste tipo, como a apresentação comercial.',
      pendingFile: '{name} será anexado ao salvar.',
      removeFile: 'Remover o anexo',
      descriptionHint: 'Aparece para quem agenda a atividade.',
      channelHint: 'O tipo do acompanhamento quando a atividade é feita.',
      defaultDueDaysHint: 'Dias até a data, ao agendar. Vazio: sem sugestão.',
      columns: {
        name: 'Tipo',
        channel: 'No histórico',
        defaultDueDays: 'Prazo padrão',
        pending: 'A fazer',
        total: 'Total',
        active: 'Situação',
        extras: 'E-mail e automação',
      },
      days: 'No mesmo dia | 1 dia | {n} dias',
      active: 'Ativo',
      inactive: 'Inativo',
      emptyTitle: 'Nenhum tipo de atividade',
      emptyText: 'Cadastre as ações padrão da equipe comercial, como "Envio de Apresentação Comercial".',
      hint: 'Tipo com atividades não pode ser excluído: inative-o para não aparecer em atividades novas. As automações (criar atividades sozinhas) vêm a seguir.',
      deleteText: 'O tipo de atividade será excluído.',
    },
  },
}
